export default "__VITE_ASSET__dc0e9453__"